import React, { useState, Fragment } from 'react';
import {
  Row, Input, Label, Button, CustomInput,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';
import { CSVLink } from 'react-csv';
import { Colxx } from '../../../../../components/common/CustomBootstrap';

import { AxiosAPI } from '../../../../../helpers/AxiosAPI';
import { putAPI_Update_Contacts } from '../../../../../constants/APIs';
import Validation from '../../../../../components/Validation';
import IntlMessages from '../../../../../helpers/IntlMessages';
export default function TicketsContactsForm({ images, id, visible, toggle, isMissingURL, csvReport, csvTicket }) {
  const [selectType, setSelectType] = useState("0");
  const [inputFields, setInputFields] = useState(images.filter(x => x.type === "DailyTickets" || x.type === "WeeklyTickets" || x.type === "MonthlyTickets"));
  const [allContacts, setAllContacts] = useState(images.filter(x => x.type !== "DailyTickets" && x.type !== "WeeklyTickets" && x.type !== "MonthlyTickets"));
  const [isEditing, setIsEditing] = useState(false);
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);
  const handleAddFields = () => {
    const values = [...inputFields];
    values.push({
      type: 'DailyTickets',
      name: '',
      email: '',
      phoneNumber: '',
      isBcc: false
    });
    setInputFields(values);
    setIsEditing(true);
  };

  const handleRemoveFields = (index) => {
    const values = [...inputFields];
    values.splice(index, 1);
    setInputFields(values);
    setIsEditing(true);
  };

  const handleInputChange = (index, event) => {
    const values = [...inputFields];
    if (event.target.name === 'name') {
      values[index].name = event.target.value;
    } else if (event.target.name === 'email') {
      values[index].email = event.target.value;
    } else if (event.target.name === 'phoneNumber') {
      values[index].phoneNumber = event.target.value;
    } else {
      values[index].type = event.target.value;
    }

    setInputFields(values);
    setIsEditing(true);
  };

  const handleCheckChange = (index, e) => {
    const values = [...inputFields];
    if (e.target.checked) {
      values[index].isBcc = true;
    }
    else {
      values[index].isBcc = false;
    }
    setInputFields(values);
    setIsEditing(true);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const data = { contacts: [...inputFields, ...allContacts], updater: 'admin' };
    AxiosAPI({
      method: 'put',
      url: `${putAPI_Update_Contacts}/${id}`,
      data,
    }).then((res) => {
      if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
        && res.data.Messages !== null && res.data.Messages.length > 0) {
        setMsg(res.data.Messages);
        setOpen(true);
      }
      else {
        setTimeout(() => {
          window.location.reload();
        }, 300);
      }
    }
    );
  };
  const handleOk = () => {

  }
  return (
    <Modal isOpen={visible} toggle={toggle} size="xl">
      <ModalHeader toggle={toggle}>Export CSV
        <p className='mt-2'>You can choose to download tickets as a CSV file or subscribe to receive daily, weekly, or monthly export.</p>
      </ModalHeader>

      <ModalBody>
        <Row>
          <Colxx sm={6}>
            <Input className='mb-2'
              type="select"
              value={selectType}
              name="selectType"
              onChange={(e) => setSelectType(e.target.value)}
            >
              <option value="0">--Select--</option>
              <option value="Download">Download CSV</option>
              <option value="SubscribeEmail">Subscribe to Email</option>
            </Input>
          </Colxx>
          <Colxx sm={6}>
            {selectType === "Download" &&
              <Fragment>
                {isMissingURL === 'missingresponse' ?
                  <Fragment>{csvReport.data.length > 0 ? (
                    <Button
                      size="xs"
                      color="dark"
                      className="mb-2"
                    >
                      <CSVLink {...csvReport}>
                        <span style={{ color: 'white' }}>
                          Download CSV
                        </span>
                      </CSVLink>
                    </Button>
                  ) : (
                    <Button
                      size="xs"
                      color="dark"
                      className="mb-2"
                    >
                      <span style={{ color: 'white' }}>
                        Download CSV
                      </span>
                    </Button>
                  )}
                  </Fragment>
                  :
                  <Fragment>
                    {csvTicket.length >
                      0 ? (
                      <Button
                        size="xs"
                        color="dark"
                        className="mb-2"
                      >
                        <CSVLink data={csvTicket} headers={[
                          { key: "r1", label: "" },
                          { key: "r2", label: "" },
                          { key: "r3", label: "" },
                          { key: "r4", label: "" },
                          { key: "r5", label: "" },
                          { key: "r6", label: "" },
                          { key: "r7", label: "" },
                        ]} filename="ticket-summary.csv">
                          <span style={{ color: 'white' }}>
                            Download CSV
                          </span>
                        </CSVLink>
                      </Button>
                    ) : (
                      <Button
                        size="xs"
                        color="dark"
                        className="mb-2"
                      >
                        <span style={{ color: 'white' }}>
                          Download CSV
                        </span>
                      </Button>
                    )}
                  </Fragment>
                }
              </Fragment>}
          </Colxx>
        </Row>
        {selectType === "SubscribeEmail" &&
          <div>
            <Row className='mt-4'>
              {inputFields?.length > 0 && (
                <Fragment>
                  <Colxx sm={3} className="mb-2">
                    <Label>Type</Label>
                  </Colxx>
                  <Colxx sm={2} className="mb-2">
                    <Label>Name</Label>
                  </Colxx>
                  <Colxx sm={3} className="mb-2">
                    <Label>Email</Label>
                  </Colxx>
                  <Colxx sm={2} className="mb-2">
                    <Label>Phone Number</Label>
                  </Colxx>
                  <Colxx sm={1} className="mb-2">
                    <Label>BCC</Label>
                  </Colxx>
                  <Colxx sm={1} className="mb-2">
                    <Label>Remove</Label>
                  </Colxx>
                </Fragment>
              )
              }
              {/* Input Rows */}
              {inputFields.map((contact, index) => (
                <Fragment key={index}>
                  <Colxx sm={3} className="mb-3">
                    <Input
                      type="select"
                      value={contact.type}
                      name="type"
                      onChange={(event) => handleInputChange(index, event)}
                    >
                      <option value="DailyTickets">Daily Emails</option>
                      <option value="WeeklyTickets">Weekly Emails</option>
                      <option value="MonthlyTickets">Monthly Emails</option>
                    </Input>
                  </Colxx>
                  <Colxx sm={2} className="mb-3">
                    <Input
                      type="text"
                      name="name"
                      value={contact.name}
                      onChange={(event) => handleInputChange(index, event)}
                    />
                  </Colxx>
                  <Colxx sm={3} className="mb-3">
                    <Input
                      type="text"
                      name="email"
                      min={1}
                      value={contact.email}
                      onChange={(event) => handleInputChange(index, event)}
                    />
                  </Colxx>
                  <Colxx sm={2} className="mb-3">
                    <Input
                      type="text"
                      name="phoneNumber"
                      min={1}
                      value={contact.phoneNumber}
                      onChange={(event) => handleInputChange(index, event)}
                    />
                  </Colxx>

                  <Colxx sm={1} className="mb-3">
                    <CustomInput
                      type="checkbox"
                      id="bcc"
                      checked={contact.isBcc}
                      name="isBcc"
                      onChange={(e) => handleCheckChange(index, e)}
                    />
                  </Colxx>

                  <Colxx sm={1} className="mb-3">
                    <Button
                      onClick={() => handleRemoveFields(index)}
                      color="secondary"
                      size="xs"
                      outline
                      style={{ margin: '6px' }}
                    >
                      -
                    </Button>
                  </Colxx>
                </Fragment>
              ))}
            </Row>
            <Button className='mt-4'
              onClick={handleAddFields}
              color="primary"
              size="xs"
              outline
              style={{ margin: '6px' }}
            >
              + Add Contact
            </Button>
            {isEditing && (
              <Button className='mt-4'
                color="secondary"
                outline
                style={{ float: 'right' }}
                onClick={handleSubmit}
              >
                Save Contacts
              </Button>
            )}
            <Validation open={open} messages={msg} toggle={() => { setOpen(!open) }}></Validation>
          </div>
        }
      </ModalBody>
    </Modal >
  );
}
